import DeliveryIncome from './DeliveryIncome.vue';
import DeliveryExpense from './DeliveryExpense.vue';
import DeliveryProfit from './DeliveryProfit.vue';
import DeliveryPerPriceRatio from './DeliveryPerPriceRatio.vue';
import DeliveryTime from './DeliveryTime.vue';
import UnsuccessDeliveryCost from './UnsuccessDeliveryCost.vue';
import UnsuccessDeliveryProductCost from './UnsuccessDeliveryProductCost.vue';

function getComponentFile(name: string) {
  if (name === 'DeliveryIncome') return DeliveryIncome;
  if (name === 'DeliveryExpense') return DeliveryExpense;
  if (name === 'DeliveryProfit') return DeliveryProfit;
  // FIXME: พี่ยีทำตรงนี้ไว้ต้องเป็น component ไหนหว่าพี่ //ลืมสร้างไว้ให้ครับ
  if (name === 'DeliveryPerPriceRatio') return DeliveryPerPriceRatio;
  if (name === 'DeliveryTime') return DeliveryTime;
  if (name === 'UnsuccessDeliveryCost') return UnsuccessDeliveryCost;
  if (name === 'UnsuccessDeliveryProductCost') return UnsuccessDeliveryProductCost;
  return null;
}

export const moduleList = [
  {
    path: 'delivery-income',
    name: 'DeliveryIncome',
    display: 'รายได้ค่าขนส่ง (Revenue)',
  },
  {
    path: 'delivery-expense',
    name: 'DeliveryExpense',
    display: 'ต้นทุนค่าขนส่ง (Expense)',
  },
  {
    path: 'delivery-profit',
    name: 'DeliveryProfit',
    display: 'กำไรค่าขนส่ง (Profit)',
  },
  {
    path: 'delivery-per-price',
    name: 'DeliveryPerPriceRatio',
    display: 'ค่าขนส่งต่อมูลค่าสินค้า (%T)',
  },
  {
    path: 'delivery-time',
    name: 'DeliveryTime',
    display: 'ระยะเวลาจัดส่ง (Duration)',
  },
  {
    path: 'unsuccess-delivery',
    name: 'UnsuccessDeliveryCost',
    display: 'มูลค่าขนส่งจัดส่งไม่สำเร็จ (Reject)',
  },
  {
    path: 'unsuccess-product',
    name: 'UnsuccessDeliveryProductCost',
    display: 'มูลค่าสินค้าจัดส่งไม่สำเร็จ (Product)',
  },
  // {
  //   path: 'income-by-transfer',
  //   name: 'AnalyticsIncomeByTransfer',
  //   display: 'รายได้ค่าขนส่ง (Revenue)',
  // },
  // {
  //   path: 'income-by-transfer-item',
  //   name: 'AnalyticsIncomeByTransferItem',
  //   display: 'ดัชนีราคา (Price Index)',
  // },
  // {
  //   path: 'expense',
  //   name: 'AnalyticsExpense',
  //   display: 'ต้นทุนค่าขนส่ง (Cost)',
  // },
  // // FYI: Hide because TMS-599
  // {
  //   path: 'average-expense',
  //   name: 'AnalyticsAverageExpense',
  //   display: 'ดัชนีต้นทุน (Cost Index)',
  // },
  // {
  //   path: 'income',
  //   name: 'AnalyticsIncome',
  //   display: 'กำไรขั้นต้น และกำไรสุทธิ (%GP, %NP)',
  // },
  // // FYI: Hide because TMS-601
  // {
  //   path: 'expense-with-item',
  //   name: 'AnalyticsExpenseByTransferItem',
  //   display: 'ต้นทุนค่าขนส่งต่อมูลค่าสินค้า (%T)',
  // },
  // {
  //   path: 'expense-failed-transfer',
  //   name: 'AnalyticsExpenseByFailedTransfer',
  //   display: 'จัดส่งไม่สำเร็จ (Return / Reject)',
  // },
];

export default moduleList.map((module: any) => ({
  path: module.path,
  name: module.name,
  component: getComponentFile(module.name),
}));
